import { render, staticRenderFns } from "./ActionConfig.vue?vue&type=template&id=639519cd&scoped=true"
import script from "./ActionConfig.vue?vue&type=script&lang=js"
export * from "./ActionConfig.vue?vue&type=script&lang=js"
import style0 from "./ActionConfig.vue?vue&type=style&index=0&id=639519cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639519cd",
  null
  
)

export default component.exports